export default __webpack_public_path__ + "static/award-2024-I-af366586aae6d8ddee2c0cd4232a4396.png";